import * as React from "react";
import { useState, useEffect } from "react";
import Loader from "../../core/Loader";
import * as moment from "moment";
import {
  DashboardContainer,
  DashboardSectionContainer,
  setInitialMonthsYears,
  setFormattedMonthData,
  setFormattedYearsData,
} from "../../../libs/commission_calculator_dashboard";
import { ChartHeader } from "./ChartHeader";
import { QuotaAvgDashboardSection } from "./QuotaAvgDashboardSection";
import { DateRange } from "./DateRange";
import { DropDown } from "./DropDown";

interface IProps {
  salespeople?: any;
  commissionsAll?: any;
}

function DashboardOverViewManager({ salespeople, commissionsAll }: IProps) {
  const [loadingMonths, setLoadingMonths] = useState(true);

  const [loadingYears, setLoadingYears] = useState(true);

  const [monthSelectedStart, setMonthSelectedStart] = useState(
    moment()
      .subtract(1, "month")
      .toDate()
  );

  const [monthSelectedEnd, setMonthSelectedEnd] = useState(moment().toDate());

  const [yearSelected, setYearSelected] = useState(null);

  const [monthData, setMonthData] = useState(null);

  const [monthTeamData, setMonthTeamData] = useState(null);

  const [yearOptions, setYearOptions] = useState(null);

  const [yearData, setYearData] = useState(null);

  const [yearTeamData, setYearTeamData] = useState(null);

  // If value for commissionsAll changes (this should only happen during initial load),
  // Then set the intial month start and end and set the selected year (based on latest commission)
  useEffect(() => {
    if (commissionsAll) {
      const commissionsSet = [...commissionsAll];
      if (commissionsSet) {
        setInitialMonthsYears({
          commissionsSet,
          setMonthSelectedStart,
          setMonthSelectedEnd,
          setYearOptions,
          setYearSelected,
        });
      }
    }
  }, [commissionsAll]);

  // If start and end dates change, then set months data after formatting for bar graph
  useEffect(() => {
    setLoadingMonths(true);
    if (
      commissionsAll &&
      Array.isArray(commissionsAll) &&
      monthSelectedStart &&
      monthSelectedEnd
    ) {
      setFormattedMonthData({
        commissionsAll,
        monthSelectedStart,
        monthSelectedEnd,
        setLoadingMonths,
        setMonthData,
        setMonthTeamData,
      });
    }
  }, [monthSelectedStart, monthSelectedEnd, commissionsAll]);

  // If selected year changes then set the year data after formatting for bar graph
  useEffect(() => {
    setLoadingYears(true);
    if (
      yearSelected &&
      commissionsAll &&
      Array.isArray(commissionsAll) &&
      commissionsAll.length > 0
    ) {
      setFormattedYearsData({
        commissionsAll,
        yearSelected,
        setLoadingYears,
        setYearData,
        setYearTeamData,
      });
    }
  }, [yearSelected, commissionsAll]);

  const AverageQuotaMonthSection = () => (
    <DashboardSectionContainer>
      <ChartHeader
        title={`${moment(monthSelectedStart).format("MMMM")} to ${moment(
          monthSelectedEnd
        ).format("MMMM")}`}
      >
        <DateRange
          monthSelectedStart={monthSelectedStart}
          setMonthSelectedStart={setMonthSelectedStart}
          monthSelectedEnd={monthSelectedEnd}
          setMonthSelectedEnd={setMonthSelectedEnd}
        />
      </ChartHeader>
      {loadingMonths ? (
        <Loader />
      ) : monthData.length > 0 && monthTeamData.length > 0 ? (
        <QuotaAvgDashboardSection
          dataTeamBar={monthTeamData}
          dataBar={monthData}
          collapsible={true}
        />
      ) : (
        <div>No data to display</div>
      )}
    </DashboardSectionContainer>
  );

  const AverageQuotaYearSection = () => (
    <DashboardSectionContainer>
      <ChartHeader title={yearSelected}>
        <DropDown
          selected={{ label: yearSelected, value: yearSelected }}
          setSelected={setYearSelected}
          options={yearOptions}
        />
      </ChartHeader>
      {loadingYears ? (
        <Loader />
      ) : yearData.length > 0 && yearTeamData.length > 0 ? (
        <QuotaAvgDashboardSection
          dataTeamBar={yearTeamData}
          dataBar={yearData}
          collapsible={true}
        />
      ) : (
        <div>No data to display</div>
      )}
    </DashboardSectionContainer>
  );   
  return (
    <DashboardContainer>
      <AverageQuotaMonthSection />
      <AverageQuotaYearSection />
    </DashboardContainer>
  );
}

export default DashboardOverViewManager;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DashboardOverViewManager.tsx